import { prefixes, prependIntlIds } from "../utils";

export const unprefixedFeedbackModalsMessages = {
  "bug_report.report_a_bug": "Nahlásit chybu",
  "bug_report.please_describe_the_bug":
    "Popište prosím problém a jak k němu došlo",

  "feedback.send_feedback": "Zaslat zpětnou vazbu",
  "feedback.message_here": "Zde zanechte svou zprávu",
} as const;

export default prependIntlIds(
  prefixes.feedback,
  unprefixedFeedbackModalsMessages
);
